module.exports = __webpack_public_path__ + "img/drugs.b2333cde.svg";